import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SupportContact } from '../../Models/common/SupportContact';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getSupportContacts(): Observable<SupportContact[]> {
    return this.http.get<SupportContact[]>(`${this.apiUrl}/get-support-contacts`);
  }
}
